import loadable from '@loadable/component';

export const OrgDashboardIntegrateAtsLinksPageLoadable = loadable(
  () => import('./OrgDashboardIntegrateAtsLinksPage'),
  { resolveComponent: (module) => module.OrgDashboardIntegrateAtsLinksPage },
);
